// SAVE
export const SAVE_DIAGNOSTIC = 'save_diagnostic';
export const SAVE_DELINEATION = 'save_delineation';
export const SAVE_PAGE = 'save_page';

// PAGES
export const PAGE_HR = 'page:hr';
export const PAGE_ZOOM = 'page:zoom';
export const PAGE_NOISE = 'page:noise';
export const PAGE_RAW = 'page:raw';
export const PAGE_ILR = 'page:ilr';

// TOOL
export const USE_RULER = 'use_ruler';
export const STOP_RULER = 'stop_ruler';
export const LOCK_RULER = 'lock_ruler';
export const MEASURE_EPISODE_DURATION = 'measure_episode_duration';
export const STOP_MEASURE_EPISODE_DURATION = 'stop_measure_episode_duration';

// CHANGE LEAD
export const CHANGE_LEAD = 'change_lead';

// CHANGE AMPLITUDE
export const CHANGE_AMPLITUDE = 'change_amplitude';

// CHANGE LEAD PLOT UNIT
export const CHANGE_LEAD_PLOT_UNIT = 'change_lead_plot_unit';

// WAVES
export const CREATE_WAVE = 'create_wave';
export const CREATE_NOISE_WAVE = 'create_noise_wave';
export const DELETE_WAVE = 'delete_wave';
export const DELETE_NOISE_WAVE = 'delete_noise_wave';

// DIAGNOSTICS
export const IMPORT_DIAGNOSTIC = 'import_diagnostic';
export const COMMENT_DIAGNOSTIC = 'comment_diagnostic';
export const ADD_DIAGNOSTIC_LABEL = 'add_diagnostic_label';
export const DELETE_DIAGNOSTIC_LABEL = 'delete_diagnostic_label';
export const SELECT_DIAGNOSTIC = 'select_diagnostic';

// TAG
export const ADD_WAVE_TAG = 'add_wave_tag';
export const CHANGE_WAVE_TAG = 'change_wave_tag';
export const DELETE_WAVE_TAG = 'delete_wave_tag';

// ECG
export const CLICK_NEXT = 'click_next';
export const UNSAVED_CHANGES_DISPLAYED = 'unsaved_changes_displayed';

// DELINEAION
export const SELECT_DELINEATION = 'select_delineation';
export const IMPORT_DELINEATION = 'import_delineation';
